let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gJYWW")).then(() => parcelRequire('4CMeD'));